import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnDestroy,
} from '@angular/core';
import {
    DateAdapter,
    MatDateFormats,
    MAT_DATE_FORMATS,
} from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: './artstuff-header.component.html',
    styleUrls: ['./artstuff-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArtstuffHeaderComponent<D> implements OnDestroy {
    private readonly destroy$ = new Subject<void>();

    constructor(
        private calendar: MatCalendar<D>, // calendar instance of picker
        private dateAdapter: DateAdapter<D>, // native or moment date adapter
        @Inject(MAT_DATE_FORMATS) private dateFormats: MatDateFormats, // for formatting
        cdr: ChangeDetectorRef
    ) {
        // make sure your header stays in sync with the calendar:
        calendar.stateChanges
            .pipe(takeUntil(this.destroy$)) // unsubscribe when destroyed
            .subscribe(() => cdr.markForCheck());
    }
    ngOnDestroy(): void {
        this.destroy$.next(); // will trigger unsubscription in takeUntil
    }
}
